import React, { useEffect, useState } from 'react';
import { FaUsers, FaMoneyCheckAlt, FaMoneyBillWave, FaHourglassHalf, FaPiggyBank, FaChartLine } from 'react-icons/fa';
import { supabase } from '../supabaseClient';
import '../styles/Dashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dashboard = () => {
  const [profile, setProfile] = useState();
  const [withdraw, setWithdraw] = useState();
  const [bookings, setBookings] = useState();

  useEffect(() => {
    const fetchProfile = async () => {
      const { data: usersMain } = await supabase
        .from('profiles')
        .select('*');
      setProfile(usersMain);
    }
    const fetchPending = async () => {
      const { data: pendingMain } = await supabase
        .from('withdrawal')
        .select('*');
      setWithdraw(pendingMain);
    }
    const fetchBookings = async () => {
      const { data: bookingsMain } = await supabase
        .from('bookings')
        .select('*');
      setBookings(bookingsMain);
    }
    fetchProfile();
    fetchPending();
    fetchBookings();
  }, []);

  const pendingWithdrawals = withdraw?.filter(item => item.status === 'pending') ?? [];
  const totalMainTotal = bookings?.reduce((acc, booking) => acc + booking.mainTotal, 0) ?? 0;

    const pendingBookingsTotal = bookings?.filter(booking => booking.status === 'Pending')
    .reduce((acc, booking) => acc + parseInt(booking.total), 0) ?? 0;

    const successfulWithdrawalsTotal = withdraw?.filter(item => item.status === 'successful')
    .reduce((acc, item) => acc + parseInt(item.amountWithdrawn), 0) ?? 0;
  
  const overallProfit = totalMainTotal * 0.1;
  
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(value);
  };

  // console.log(pendingBookingsTotal)

  const items = [
    { icon: <FaUsers size={24} />, heading: 'Users', value: profile?.length ?? 0, color: 'blue' },
    { icon: <FaMoneyCheckAlt size={24} />, heading: 'Transactions In', value: formatCurrency(totalMainTotal) ?? 0, color: 'green' },
    { icon: <FaMoneyBillWave size={24} />, heading: 'Transactions Out', value: formatCurrency(successfulWithdrawalsTotal), color: 'red' },
    { icon: <FaHourglassHalf size={24} />, heading: 'Pending Withdrawals', value: pendingWithdrawals.length ?? 0, color: 'orange' },
    { icon: <FaPiggyBank size={24} />, heading: 'Funds in Holding', value: formatCurrency(pendingBookingsTotal), color: 'rgba(220, 6, 224, 0.99)' },
    { icon: <FaChartLine size={24} />, heading: 'Overall Profit', value: formatCurrency(overallProfit), color: 'rgba(16, 248, 78, 0.83)' },
  ];

  return (
    <div className="container">
      <h1 className="title">Dashboard BusinessInfo</h1>
      <div className="row">
        {items.map((item, index) => (
          <div key={index} className="col-md-6 mb-4">
            <div className="card5 p-3">
              <div className="d-flex align-items-center">
                <div className={item.heading === 'Pending Withdrawals' && item.value > 0 ? 'icon-wrapper' : 'icon-wrappermain'} style={{ color: `${item.color}` }}>
                  {item.icon}
                </div>
                <div className="flex-column ms-3">
                  <h2 className="heading">{item.heading}</h2>
                  <p className="value">{item.value}</p>
                </div>
              </div>
              {/* {item.heading === 'Pending Bookings' && pendingWithdrawals > 0 && (
                <div className="notification-dot"></div>
              )} */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
